
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gangwon-parlors/[code]",
      function () {
        return require("private-next-pages/gangwon-parlors/[code]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gangwon-parlors/[code]"])
      });
    }
  